import { useState } from 'react'
import { useWebContent } from '../lib/webPrices'
import { assetUrl } from '../lib/api'

// Galerie = fotky, které se NEopakují v jiných sekcích; kategorie prokládané kvůli pestrosti.
const PHOTOS = [
  '/img/tenis_01_ctyrhra.webp',           // tenis — čtyřhra na kurtu
  '/img/rybolov_kapr_voda.jpg',           // rybolov — kapr ve vodě
  '/img/gal_new_28.jpg',                  // restaurace
  '/img/rybolov_kapr_noc.jpg',            // rybolov — noční úlovek
  '/img/tinyhouse_09_exterier_bok.jpg',   // tiny house — exteriér
  '/img/gal_17.jpg',                      // kuchyně — koleno
  '/img/tinyhouse_12_interier_terasa.jpg',// tiny house — terasa
  '/img/gal_9.jpg',                       // pokoj penzionu
  '/img/tinyhouse_07_glamping_postel.jpg',// glamping postel
  '/img/gal_18.jpg',                      // kuchyně — tatarák
  '/img/tinyhouse_10_exterier_zezadu.jpg',// tiny house — exteriér
  '/img/penzion_04_zakouti_okno.jpg',     // zákoutí penzionu
  '/img/tinyhouse_19_terasa_vino.jpg',    // tiny house — terasa
  '/img/banner_3.jpg',                    // pokoj penzionu
  '/img/tinyhouse_11_obyvak.jpg',         // tiny house — obývák
  '/img/tinyhouse_06_sauna_okno.jpg',     // tiny house — sauna
  '/img/penzion_02_pokoj_postele.jpg',    // pokoj penzionu
  '/img/tinyhouse_16_loznice_postel.jpg', // tiny house — ložnice
  '/img/tinyhouse_14_okno_posezeni.jpg',  // tiny house — posezení
]

export function Gallery() {
  const [lightbox, setLightbox] = useState<string | null>(null)
  const content = useWebContent()
  const photos = content.gallery_images?.length
    ? content.gallery_images.map((u) => assetUrl(u) || u)
    : PHOTOS

  return (
    <section id="galerie" className="py-20 md:py-28 bg-white">
      <div className="container-x">
        <div className="max-w-3xl">
          <p className="h-eyebrow">Galerie</p>
          <h2 className="h-display text-3xl md:text-[44px] mt-4">Areál <span className="h-accent">Sobáčov</span></h2>
          <p className="mt-5 text-ink-700 text-base md:text-lg">
            Záběry z&nbsp;areálu, rybníka, ubytování i&nbsp;sezónních akcí.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2 md:gap-3">
          {photos.map((src) => (
            <button
              key={src}
              onClick={() => setLightbox(src)}
              className="group relative overflow-hidden rounded-xl bg-ink-900/5 aspect-square"
            >
              <img
                src={src}
                alt=""
                className="w-full h-full object-cover group-hover:scale-[1.04] transition-transform duration-500"
                loading="lazy"
              />
            </button>
          ))}
        </div>
      </div>

      {lightbox && (
        <div
          onClick={() => setLightbox(null)}
          className="fixed inset-0 z-[80] bg-ink-900/95 flex items-center justify-center p-4 cursor-pointer"
        >
          <img src={lightbox} alt="" className="max-w-full max-h-[95vh] object-contain rounded-lg" />
          <button
            onClick={() => setLightbox(null)}
            className="absolute top-5 right-5 text-white bg-white/10 hover:bg-white/20 w-10 h-10 grid place-items-center rounded-lg transition-colors"
          >
            <svg viewBox="0 0 24 24" className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M6 6l12 12M18 6L6 18" /></svg>
          </button>
        </div>
      )}
    </section>
  )
}
